import { MetadataEntityData, MetadataEntityFieldData, MetadataEntityFieldDomain } from '@jms/model';
import { resolveColumnUiFields } from '../../queue.field.options';

// Column options drop dotted paths (they are how stage fields are told apart), so the accounting sync fields an
// error queue needs are added back by name rather than opening every embedded sub-field to the picker
const ACCOUNTING_COLUMN_PATHS = ['integration.status', 'integration.date', 'integration.error'];

// Internal bookkeeping, long text, or lists that do not fit a table cell. The invoice and bill boards keep them.
const HIDDEN_COLUMN_PATHS = new Set([
  'version', 'timesheetIds', 'pricebook', 'theme', 'hasPayments', 'hasAllocation', 'updatedAt', 'generatedDate',
  'notes', 'lines', 'taxInclusiveOption', 'taxRate', 'attachments', 'terms', 'timezone', 'modifiedAfterSend', 'source',
  'roundingAmount', 'isReconcile', 'systemTags',
]);

/** The fields an invoice or bill queue offers as columns. */
export function financeQueueColumnFields(meta: MetadataEntityData): MetadataEntityFieldData[] {

  const uiFields = new MetadataEntityFieldDomain(meta).uiFields;
  const accounting = ACCOUNTING_COLUMN_PATHS.map(path => uiFields[path]).filter(field => !!field);
  const visible = resolveColumnUiFields(meta).filter(field => !HIDDEN_COLUMN_PATHS.has(field.path ?? field.name));

  return [...visible, ...accounting];
}
